export const CNAME = {
  PBB_UI_TOKEN: 'PBB_TOKEN',
};
